
import { defineComponent } from 'vue'

export default defineComponent({
    name: 'member-form-field-allow-in-whole-organization',
    emits: ['update:modelValue'],
    props: {
        modelValue: {
            type: String
        },
        label: {
            type: String,
            default: 'Authorized to see whole organization report'
        }
    }
})
